
























































/* General */
import Vue from 'vue'
import RouteAssistant from '@/helpers/route-assistant'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  name: 'AppHeaderAddGlobal',

  data() {
    return {
      RouteAssistant,
    }
  },
})
